"use client";

import { useState } from "react";
import { Plus, Cpu, Layers, Wrench, CircleCheck as CheckCircle2 } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const [activeStage, setActiveStage] = useState(0);
  const stages = [{
    number: "01",
    title: "ΑΠΕΥΘΕΙΑΣ ΠΡΟΣΒΑΣΗ",
    description: "Εξασφαλίστε άμεση επικοινωνία με τα κορυφαία καταλύματα στην Ελλάδα. Η τεχνολογία μας σας συνδέει απευθείας με τους ιδιοκτήτες, προσφέροντας τις καλύτερες διαθέσιμες τιμές της αγοράς.",
    metric: "Άμεση Πρόσβαση",
    icon: Cpu,
    diagram: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698288/img/direct_connection_andros.png",
    diagramAlt: "Διάγραμμα απευθείας σύνδεσης με ξενοδοχεία"
  }, {
    number: "02",
    title: "ΕΓΓΥΗΣΗ ΤΙΜΗΣ",
    description: "Η τεχνολογία μας σαρώνει την αγορά σε πραγματικό χρόνο. Αν βρείτε χαμηλότερη τιμή για το ίδιο δωμάτιο, την καλύπτουμε. Διαφάνεια σε κάθε κράτηση.",
    metric: "Best Price Guarantee",
    icon: Layers,
    diagram: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698288/img/price_guarantee_system.png",
    diagramAlt: "Τεχνικό διάγραμμα σύγκρισης τιμών"
  }, {
    number: "03",
    title: "ΑΣΦΑΛΕΙΣ ΣΥΝΑΛΛΑΓΕΣ",
    description: "Κρυπτογραφημένες πληρωμές και άμεση επιβεβαίωση. Η κράτησή σας οριστικοποιείται στο σύστημα του ξενοδοχείου μέσα σε δευτερόλεπτα από την ολοκλήρωση.",
    metric: "SSL 256-bit Encryption",
    icon: Wrench,
    diagram: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698288/img/secure_booking_flow.png",
    diagramAlt: "Διάγραμμα ροής ασφαλών συναλλαγών"
  }, {
    number: "04",
    title: "ΥΠΟΣΤΗΡΙΞΗ VLM",
    description: "Με την υπογραφή της VLM Travel, έχετε 24/7 υποστήριξη από επαγγελματίες του τουρισμού. Δεν είστε ποτέ μόνοι σας, από την κράτηση μέχρι το check-out.",
    metric: "24/7 VIP Support",
    icon: CheckCircle2,
    diagram: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698288/img/vlm_travel_support.png",
    diagramAlt: "Διάγραμμα υποστήριξης πελατών VLM"
  }];
  const certifications = ["POWERED BY VLM TRAVEL", "GNTO LICENSED 1166Ε60000912901"];
  const {
    headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const activeDiagram = stages[activeStage];
  return;
}